import React from 'react';
import { DdtChangeEventArgs, DropDownTreeComponent } from '@syncfusion/ej2-react-dropdowns';
import FacilityStore from '../stores/FacilityStore';
import FacilityActions from '../actions/FacilityActions';
import OntologyActions from '../actions/OntologyActions';
const { useState, useEffect } = React;

interface OntologyDropDownProps {
    selectedOntology: IOntologyPart;    
    readonly: boolean;
}

const OntologyDropDown: React.FC<OntologyDropDownProps> = ({ selectedOntology, readonly }) => {
    const [facilityHierarchy] = useState<IFacilityHierarchyPart>(FacilityStore.getFacilityHierarchy());

    const onChangeFacilitySelection = (args: DdtChangeEventArgs): void => {
        if (!args.isInteracted)
            return;

        let selectedId = args.value && args.value.length > 0 ? args.value[0] : '';

        const facility = FacilityStore.getSelectedFacility();
        const selectedItem = facility.OntologyParts.find(part => part.ID === selectedId);
        if (!selectedItem?.OntologyParentID) {
            selectedId = '';
        }

        OntologyActions.selectOntology(selectedItem);
    }

    const convertToDropDownTreeData = (node: IFacilityHierarchyPart): any => {
        return {
            nodeId: node.ID,
            nodeText: node.Name,
            icon: !node.OntologyParentID ? "faciliy-icon" : "building-icon",
            nodeChild: node.Children && node.Children.length > 0
                ? node.Children.map(convertToDropDownTreeData)
                : undefined,
            expanded: true // Ensure all nodes are expanded by default
        };
    };

    const transformedData = [convertToDropDownTreeData(facilityHierarchy)];

    const fields = {
        dataSource: transformedData,
        value: 'nodeId',
        text: 'nodeText',
        child: 'nodeChild',
        iconCss: 'icon'
    };
    return (
        <div className='facility-selection'>
            <div className='control_wrapper'>
                <DropDownTreeComponent fields={fields} change={onChangeFacilitySelection.bind(this)} changeOnBlur={false} placeholder={InovxLoader.t('facility:knowledgeBook.facility')} popupHeight="200px" enabled={!readonly} cssClass="facility-dropdown" value={selectedOntology?.ID ? [selectedOntology?.ID] : []} showClearButton={false} />
            </div>
        </div>
    );
}

export default OntologyDropDown;
